import React, { Component } from 'react';
import { Link, browserHistory, withRouter } from 'react-router';
import classNames from 'classnames';

import Icon from '../common/components/Icon';

import T from '../common/translation';

export default props => {
	const {
		user,
		isSaving,
		routeIndex,
		logout,
		login,
		isAuthenticated
	} = props;

	const userText = __COM__
		? `Connecté en tant que ${user.civility} ${user.firstname} ${
				user.lastname
			}`
		: user.firstname
			? `Bonjour, ${user.civility} ${user.lastname} ${user.firstname}`
			: 'Mode découverte';

	const buttonText = isAuthenticated ? 'Déconnexion' : 'Se connecter';

	const onClick = user.firstname ? logout : login;
	return (
		<header className="header">
			<HomeLink />
			<Stepper />
			<UserItem
				greetingText={userText}
				buttonText={buttonText}
				routeIndex={routeIndex}
				isSaving={isSaving}
				onClick={onClick}
			/>
		</header>
	);
};

const UserItem = ({
	greetingText,
	buttonText,
	routeIndex,
	isSaving,
	onClick
}) => {
	const greetingClasses = classNames({
		'header__greeting-wrapper': true,
		'is-translated': routeIndex === 1
	});
	const saveIndicatorClasses = classNames({
		'header__save-indicator-wrapper': true,
		'is-opaque': routeIndex === 1
	});
	return (
		<div className="header__item--last u-flex">
			<div
				style={{ minWidth: '170px', marginRight: '10px' }}
				className="u-flex u-flex--col u-flex--justify-center u-flex--align-items-start"
			>
				<div className={greetingClasses}>
					<Greeting displayText={greetingText} />
				</div>
				<div className={saveIndicatorClasses}>
					<SaveIndicatorContainer isSaving={isSaving} />
				</div>
			</div>
			<LogoutButton displayText={buttonText} onClick={onClick} />
		</div>
	);
};

const Greeting = ({ displayText }) => (
	<span className="header__greeting">{displayText}</span>
);

const HomeLink = props => (
	<a
		className="header__item header__item--home"
		href="http://capitaine-cles.fr"
	>
		<span className="header__flex-fix">
			<Icon icon="home" />
			Accueil
		</span>
	</a>
);

class SaveIndicatorContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasRouteChanged: false,
			isDelayed: false
		};
	}
	componentWillReceiveProps(nextProps) {
		const routeIndex = this.props.routes[this.props.routes.length - 1]
			.index;
		const nextRouteIndex =
			nextProps.routes[nextProps.routes.length - 1].index;

		if (nextRouteIndex !== routeIndex) {
			this.setState({ hasRouteChanged: true });
		} else {
			//this.setState({ hasRouteChanged: false });
		}

		if (nextProps.isSaving) {
			this.setState({ isDelayed: true, hasRouteChanged: false });
			setTimeout(() => {
				this.setState({ isDelayed: false });
			}, 1000);
			return;
		}
	}
	render() {
		let saveText = '';
		if (this.state.hasRouteChanged) {
			const routeIndex = this.props.routes[this.props.routes.length - 1]
				.index;
			switch (routeIndex) {
				// Project & clone routes
				case 1:
					saveText = '\xa0';
					break;
				// Plan route
				case 2:
					saveText = 'Sauvegarde automatique';
					break;
				// Offers & confirmation routes
				case 3:
				case 4:
					saveText = 'Projet sauvegardé';
					break;
				default:
					saveText = '';
			}
		} else {
			if (this.props.isSaving || this.state.isDelayed) {
				saveText = 'Enregistrement en cours...';
			} else {
				saveText = 'Modifications enregistrées';
			}
		}

		return <SaveIndicator saveText={saveText} />;
	}
}

SaveIndicatorContainer = withRouter(SaveIndicatorContainer);

const SaveIndicator = ({ saveText }) => (
	<span className="header__save-indicator">{saveText}</span>
);

const LogoutButton = ({ displayText, onClick }) => (
	<button className="header__item header__item--logout" onClick={onClick}>
		<span className="header__flex-fix">
			<Icon icon="logout" />
			{displayText}
		</span>
	</button>
);

const DiscoverButton = props => (
	<button className="header__item--discover">
		<span className="header__flex-fix">
			<Icon icon="binoculars" size="large" />
			Mode découverte
		</span>
	</button>
);

const Stepper = withRouter(props => {
	const { projectId } = props.params;
	const routeIndex = props.routes[props.routes.length - 1].index;
	return (
		<div className="c-stepper">
			<Step
				number="1"
				name="Mes projets"
				path="/app/project-v2"
				isActive={routeIndex === 1}
				isCompleted={routeIndex > 1}
			/>
			<StepSeparator />
			<Step
				number="2"
				name="Plan"
				path={`/app/project/${encodeURIComponent(projectId)}/plan`}
				isActive={routeIndex === 2}
				isCompleted={routeIndex > 2}
			/>
			<StepSeparator />
			<Step
				number="3"
				name="Choix de l'offre"
				path={`/app/project/${encodeURIComponent(projectId)}/offers`}
				isActive={routeIndex === 3}
				isCompleted={routeIndex > 3}
			/>
		</div>
	);
});

const Step = ({ number, name, path, isActive, isCompleted, onClick }) => {
	const setpClasses = classNames({
		'c-stepper__step': true,
		'is-active': isActive,
		'is-completed': isCompleted
	});
	const stepNumberClasses = classNames({
		'c-stepper__step-number': true,
		'is-active': isActive,
		'is-completed': isCompleted
	});
	const stepNameClasses = classNames({
		'c-stepper__step-name': true,
		'is-active': isActive,
		'is-completed': isCompleted
	});
	return (
		<div
			className={setpClasses}
			onClick={() => {
				// For iAdvice resync.
				if (isActive) location.reload();
				if (isCompleted) browserHistory.push(path);
			}}
		>
			<span className={stepNumberClasses}>{number}</span>
			<span className={stepNameClasses}>{name}</span>
		</div>
	);
};

const StepSeparator = () => (
	<div className="c-stepper__step-separator">
		<Icon icon="arrow-right" />
	</div>
);



// WEBPACK FOOTER //
// ./src/js/app/Header.js